import { render, staticRenderFns } from "./settings-company-projects.vue?vue&type=template&id=7e3ea42e&"
import script from "./settings-company-projects.ts?vue&type=script&lang=ts&"
export * from "./settings-company-projects.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports